export default __webpack_public_path__ + "static/media/creative.485641eb.png";